import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { HttpApiResponseInterface } from 'pf-frontend-common/src/module/http/api-response.interface';
import { JsonApiPayloadInterface } from 'pf-frontend-common/src/module/json-api/payload.interface';
import { ApiServiceInterface } from 'pf-frontend-common/src/service/api/service.interface';

import { LeadStoreCreateResponseInterface } from 'common/data/lead/store/create/response.interface';
import { PropertyModel } from 'common/data/property/model';
import { PropertyLeadModel } from 'common/data/property-lead/model';
import { objectFilterNonOrEmptyValue } from 'common/helper/object/filter/non-or-empty-value';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';
import { EmailAlertStoreServiceInterface } from 'common/service/email-alert-store/service.interface';
import { PropertyLeadStoreServiceInterface } from 'common/service/property-lead-store/service.interface';
import { PropertyStoreServiceInterface } from 'common/service/property-store/service.interface';

export class PropertyLeadStore implements PropertyLeadStoreServiceInterface {
  /**
   * API endpoint
   */
  protected endpoint: { [key: string]: DataKeyValueStringInterface } = {
    create: {
      path: this.apiEndpointService.getPath('/property/{modelId}/lead'),
      method: 'POST',
    },
  };

  /**
   * Constructor
   */
  constructor(
    protected apiService: ApiServiceInterface,
    protected apiEndpointService: ApiEndpointServiceInterface,
    protected emailAlertStore: EmailAlertStoreServiceInterface,
    protected propertyStore: PropertyStoreServiceInterface
  ) {}

  /**
   * @inheritDoc
   */
  public create(modelId: string, model: PropertyLeadModel): Promise<LeadStoreCreateResponseInterface[]> {
    const createActions = [];
    let createActionAlert;

    // Prepare path
    const path = this.endpoint.create.path.replace('{modelId}', modelId);

    // Prepare payload
    const payload: JsonApiPayloadInterface = model.serialize();
    const createActionEmail = this.apiService.request(
      this.endpoint.create.method,
      path,
      objectFilterNonOrEmptyValue(payload),
      true
    );
    createActions.push(createActionEmail);

    if (model.createAlert) {
      const property = this.propertyStore.getOneById(modelId);
      createActionAlert = this.createEmailAlert(model.email, property);
      createActions.push(createActionAlert);
    }

    // TODO-FE[later] Is it so important to wait for the optional email alert registration resolve ?
    return Promise.all(createActions);
  }

  /**
   * Create email alert
   */
  private createEmailAlert(email: string, property: PropertyModel): Promise<HttpApiResponseInterface> {
    const emailAlertModel = this.emailAlertStore.createModelFromProperty(email, property);

    return this.emailAlertStore.create(emailAlertModel);
  }
}
